import React, { useState, useEffect, useCallback } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box, Typography, CardContent, CardActions, Card
} from '@mui/material';
import FiltroDeVendas from '../../components/FiltroRelatorioVendas';
import { useRelatoriosStore } from '../../store/RelatoriosStore';
import ModalRealatorioDeVendas from '../../components/ModalRelatorioDeVendas';

export default function RelatoriosVendasPage() {

    const { BuscarRelatorioDeVendas, loading } = useRelatoriosStore();
    const [abriModalRelatorioDeVendas, setabriModalRelatorioDeVendas] = useState(false);




    const HandleRelatorioVendas = useCallback((dados_do_filtro) => {
        BuscarRelatorioDeVendas(dados_do_filtro);
    }, [])



    return (
        <>
            <FiltroDeVendas
                onSearch={HandleRelatorioVendas}
            />

            <ModalRealatorioDeVendas

            />
        </>
    )
}